type ScoreDefinitionLike = {
  wellDropScoreGroupId: number;
  wellDropScoreId: number;
};

type ScoreGroupOptionLike = {
  scoreGroupsId: number;
};

export function parseSelectedScoreGroupIds(value?: string): number[] {
  if (!value?.trim()) {
    return [];
  }

  return value
    .split(',')
    .map((id) => id.trim())
    .filter((id) => id !== '')
    .map((id) => Number(id))
    .filter((id) => Number.isFinite(id));
}

export function formatSelectedScoreGroupIds(selectedGroupIds: number[]): string {
  return selectedGroupIds.join(',');
}

export function getScoreIdsForSelectedGroups(
  selectedGroupIds: number[],
  scoreDefinitions: ScoreDefinitionLike[],
): number[] {
  if (selectedGroupIds.length === 0) {
    return [];
  }

  return scoreDefinitions
    .filter((score) => selectedGroupIds.includes(score.wellDropScoreGroupId))
    .map((score) => score.wellDropScoreId);
}

export function getValidScoreGroupIds(
  selectedGroupIds: number[],
  scoreDefinitions: ScoreDefinitionLike[],
): number[] {
  const scoreGroupIds = new Set(
    scoreDefinitions.map((score) => score.wellDropScoreGroupId),
  );

  return selectedGroupIds.filter((id) => scoreGroupIds.has(id));
}

export function getSelectedScoreGroupIds(
  allScoresOptionsList: ScoreGroupOptionLike[],
  scoreGroups: number[],
  scoreDefinitions: ScoreDefinitionLike[],
): number[] {
  if (!scoreGroups?.length || !allScoresOptionsList?.length) {
    return [];
  }

  return allScoresOptionsList
    .filter((group) => {
      const groupScoreIds = scoreDefinitions
        .filter((score) => score.wellDropScoreGroupId === group.scoreGroupsId)
        .map((score) => score.wellDropScoreId);

      return (
        groupScoreIds.length > 0 && groupScoreIds.every((id) => scoreGroups.includes(id))
      );
    })
    .map((group) => group.scoreGroupsId);
}
